<template lang="html">
  <div id="loading-wrapper" @click="notBusyAnymore">
    <div class="loader">
      <h1 v-html="busyMessage"></h1>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    notBusyAnymore() {
      //FIXME: MAYBE I'LL UNCOMMENT THIS ONE DAY, BUT WE HAVE A TIMEOUT THAT REMOVES BUSY STATES IN VUEX
      // this.$store.dispatch("activity/clearAllBusy");
    },
  },
  computed: {
    busyMessage() {
      return this.$store.getters["activity/busyMessage"];
    },
  },
};
</script>

<style lang="css" scoped>
#loading-wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(75, 67, 67, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loader {
  margin: 20px auto;
  max-width: 80vw;
  border: 1px solid white;
  border-radius: 20px;
  padding: 30px;
}
h1 {
  font-family: "Actor", sans-serif;
  color: #fff;
  font-size: 18px;
  letter-spacing: 1px;
  font-weight: bolder !important;
  text-align: center;
  margin-bottom: 20px;
}
.loader span {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  left: 50%;
  margin-left: -10px;
  -webkit-animation: 3s infinite linear;
  -moz-animation: 3s infinite linear;
  -o-animation: 3s infinite linear;
}

.loader span:nth-child(2) {
  background: #e84c3d;
  -webkit-animation: kiri 1.2s infinite linear;
  -moz-animation: kiri 1.2s infinite linear;
  -o-animation: kiri 1.2s infinite linear;
}
.loader span:nth-child(3) {
  background: #f1c40f;
  z-index: 100;
}
.loader span:nth-child(4) {
  background: #2fcc71;
  -webkit-animation: kanan 1.2s infinite linear;
  -moz-animation: kanan 1.2s infinite linear;
  -o-animation: kanan 1.2s infinite linear;
}

@-webkit-keyframes kanan {
  0% {
    -webkit-transform: translateX(20px);
  }

  50% {
    -webkit-transform: translateX(-20px);
  }

  100% {
    -webkit-transform: translateX(20px);
    z-index: 200;
  }
}
@-moz-keyframes kanan {
  0% {
    -moz-transform: translateX(20px);
  }

  50% {
    -moz-transform: translateX(-20px);
  }

  100% {
    -moz-transform: translateX(20px);
    z-index: 200;
  }
}
@-o-keyframes kanan {
  0% {
    -o-transform: translateX(20px);
  }

  50% {
    -o-transform: translateX(-20px);
  }

  100% {
    -o-transform: translateX(20px);
    z-index: 200;
  }
}

@-webkit-keyframes kiri {
  0% {
    -webkit-transform: translateX(-20px);
    z-index: 200;
  }
  50% {
    -webkit-transform: translateX(20px);
  }
  100% {
    -webkit-transform: translateX(-20px);
  }
}

@-moz-keyframes kiri {
  0% {
    -moz-transform: translateX(-20px);
    z-index: 200;
  }
  50% {
    -moz-transform: translateX(20px);
  }
  100% {
    -moz-transform: translateX(-20px);
  }
}
@-o-keyframes kiri {
  0% {
    -o-transform: translateX(-20px);
    z-index: 200;
  }
  50% {
    -o-transform: translateX(20px);
  }
  100% {
    -o-transform: translateX(-20px);
  }
}
</style>
